export default "__VITE_ASSET__BSx8sc0j__"